import * as React from 'react'
import { IconName, propertyTypeToIconName } from '../../../../common/src/components/Icon'
import { formatOptPhoneNumber } from '../../../../common/src/format'
import {
  TaskType,
  FetchTasksPageQuery,
  LeasePropertyType,
  FetchUserContextQuery,
} from '../../../../common/src/types.gen'
import validate from '../../../../common/src/validate'
import { Field } from '../components/EditBox'
import EditBoxes from '../components/EditBoxes'

const taskTypes = Object.keys(TaskType)

export default class TaskEditBoxes extends React.PureComponent<{
  leasingTask: NonNullable<FetchTasksPageQuery['task']>
  user: FetchUserContextQuery['self']
  onEdit: (key: string, value: any) => Promise<any>
}> {
  render() {
    const { leasingTask, user, onEdit } = this.props
    const { leasingInfo, taskType } = leasingTask
    const model = Object.assign({}, leasingInfo, leasingTask)

    const showCoreTaskInfo = user.permissions.canViewCoreTaskInfo
    const canEditTaskDetails = user.permissions.canEditTaskDetails
    const isLeasingProp = taskType === 'LEASING_PROPERTY' && leasingInfo != null
    const canEditLaunch = showCoreTaskInfo && !leasingTask.hasLaunched
    const canEditOffboard = showCoreTaskInfo && !leasingTask.hasOffboarded

    const fields = [
      fieldTaskType,
      fieldIsBotDisabled,
      showCoreTaskInfo && fieldAddressEmail,
      showCoreTaskInfo && fieldAddressPhone,
      isLeasingProp && fieldPropertyType,
      isLeasingProp && Object.assign(fieldLaunchDate, { isEditable: canEditLaunch }),
      isLeasingProp && Object.assign(fieldOffboardDate, { isEditable: canEditOffboard }),
      isLeasingProp && fieldBuildingName,
    ].filter(f => f) as Field<any>[]

    return (
      <EditBoxes disableEdit={!canEditTaskDetails} model={model} fields={fields} displayType="small" onEdit={onEdit} />
    )
  }
}

function highlightMissing(d: any) {
  return d == null || d === '' ? 'coral' : undefined
}

function taskToIconName(val: string): IconName | undefined {
  if (val === 'LEASING_FIRM') {
    return 'task-firm'
  }
  return undefined
}

const fieldTaskType = {
  key: 'taskType',
  options: taskTypes,
  iconFunc: val => taskToIconName(val),
} as Field<TaskType>

const fieldIsBotDisabled = {
  key: 'isBotDisabled',
  isEditable: true,
  textFunc: val => (val ? 'Bot disabled' : 'Bot on'),
  editTextFunc: val => (val ? 'off' : 'on'),
  validator: validate.options({ on: false, off: true }),
  colorFunc: val => (val ? 'coral' : undefined),
} as Field<boolean>

const fieldAddressEmail = {
  key: 'addressEmail',
  textFunc: (addressEmail?: string) => addressEmail || 'missing',
  colorFunc: highlightMissing,
  iconFunc: () => 'channel-email',
} as Field<string>

const fieldAddressPhone = {
  key: 'addressPhone',
  textFunc: (addressPhone: string | null | undefined) => formatOptPhoneNumber(addressPhone) || 'missing',
  colorFunc: highlightMissing,
  iconFunc: () => 'channel-sms',
} as Field<string>

const fieldPropertyType = {
  key: 'propertyType',
  isEditable: true,
  options: Object.keys(LeasePropertyType),
  iconFunc: val => propertyTypeToIconName(val),
} as Field<LeasePropertyType>

const fieldLaunchDate = {
  key: 'launchDate',
  textFunc: val => (val ? val : '(no launch)'),
  validator: validate.isoDate().empty(''),
  colorFunc: val => (val && new Date(val).getTime() > Date.now() ? 'coral' : undefined),
} as Field<string>

const fieldOffboardDate = {
  key: 'offboardDate',
  textFunc: val => (val ? val : '(no offboarding)'),
  validator: validate.isoDate().empty(''),
  colorFunc: val => (val && new Date(val).getTime() <= Date.now() ? 'coral' : undefined),
} as Field<string>

const fieldBuildingName = {
  key: 'buildingName',
  isEditable: true,
  textFunc: (v: any) => v || 'Name?',
  editTextFunc: (v: any) => v,
} as Field<string>
